<div class="product-item col-6 col-sm-6 col-md-3" :class="{selected: value > 0}">
    <div class="card-product p-md-3 mb-md-0">
        <h3 class="card-product-title">
            <span v-if="product.d" style="font-family: Proxima Nova Bold;">
                {{ product.title }}
            </span>
            <a v-else :href="productUrl">
                {{ product.title }}
            </a>
        </h3>
        <div class="product-img" :class="{'product-is-new-label': isNew, 'coming_soon': product.coming_soon}">
            <span v-if="product.d">
                <img :src="product.img">
            </span>
            <a v-else :href="productUrl">
                <img :src="product.img">
            </a>

            <div class="label-product">
                <div class="label-class" :class="labelClass">
                    <span v-if="Number(product.class) === 11">
                        Колледжи
                    </span>
                    <span v-else>
                        <span class="index">{{ product.class }}</span> класс
                    </span>
                </div>
            </div>

            <div v-if="isNew" class="label-new">
                new!
            </div>

            <div v-if="product.coming_soon" class="coming-soon-label">
                <span class="coming-soon-text">
                Скоро в продаже
                </span>
            </div>
        </div>
        <div class="b-product-desc">
            <div v-if="!product.coming_soon" class="product-price">
                <span
                    :class="{'promo-price': promoIsOn}"
                    class="price-value"
                >
                    {{ price }}
                </span>
                <span
                    v-if="priceDiscount"
                    class="price-discount"
                >
                    {{ priceDiscount }}
                </span>
            </div>
            {{ product.description }}
        </div>

        <div v-if="!product.coming_soon" class="counter-container">
            <div class="b-nav-count-p mb-2">
                <div class="btn-counter btn-p-rm">
                    <button @click="$emit('decrement')">–</button>
                </div>
                <div class="b-product-c">
                    <input type="number" v-number-filter :value="value" @input.prevent="inputHandler">
                    <div class="hide product-c-desc">шт.</div>
                </div>
                <div class="btn-counter btn-p-add">
                    <button @click="$emit('increment')">+</button>
                </div>
            </div>
        </div>

    </div>
</div>
